var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { RowDefaultProps } from './defaults';
import Cell from './Cell';
var Row = function (props) {
    var row = props.row, layout = props.layout, hasBorder = props.hasBorder, colon = props.colon, className = props.className, rest = __rest(props, ["row", "layout", "hasBorder", "colon", "className"]);
    var renderCells = function (_a) {
        var component = _a.component, showLabel = _a.showLabel, showContent = _a.showContent;
        return row.map(function (item, index) {
            var _a = item.props, label = _a.label, children = _a.children, _b = _a.span, span = _b === void 0 ? 1 : _b;
            if (typeof component === 'string') {
                return (React.createElement(Cell, __assign({ key: index, span: span, label: showLabel ? label : null, component: component, hasBorder: hasBorder, content: showContent ? children : null, colon: colon, className: className }, rest)));
            }
            else {
                return [
                    React.createElement(Cell, __assign({ span: 1, hasBorder: hasBorder, colon: colon, component: component[0], className: className, label: label }, rest)),
                    React.createElement(Cell, __assign({ span: span * 2 - 1, hasBorder: hasBorder, component: component[1], content: children, className: className }, rest)),
                ];
            }
        });
    };
    // 垂直列表
    if (layout === 'vertical') {
        return (React.createElement(React.Fragment, null,
            React.createElement("tr", { className: "descriptions-row" }, renderCells({ component: 'th', showLabel: true })),
            React.createElement("tr", { className: "descriptions-row" }, renderCells({
                component: 'td',
                showContent: true,
            }))));
    }
    return (React.createElement("tr", __assign({ className: "descriptions-row " + className }, rest), renderCells({
        component: hasBorder ? ['th', 'td'] : 'td',
        showLabel: true,
        showContent: true,
    })));
};
Row.defaultProps = RowDefaultProps;
export default Row;
